module.exports = __webpack_public_path__ + "img/3.b72f4081.png";